// src/config/env.js
let API_URL = "";

if (typeof process !== "undefined" && process.env.REACT_APP_API_URL) {
  // React 웹용
  API_URL = process.env.REACT_APP_API_URL;
} else {
  // React Native용
  try {
    const { API_URL: RN_API_URL } = require('@env');
    API_URL = RN_API_URL;
  } catch (err) {
    console.warn("React Native 환경이 아닌 것 같습니다:", err);
  }
}

export { API_URL };

